package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ClubWidgetPayload(
    val organization: String,
    @SerialName("seasonID")
    val seasonId: String,
)
